export const m0l2Solution = `%lang starknet
// Functions can take arguments and return results
// do not modify code on this line or above

// TODO: fix the method signature to make the tests pass
func takes_two_arguments_and_returns_one(a : felt, b : felt) -> (res : felt) {

    // do not modify code on this line or below

    return (res=a+b);
}

@external
func test_sum{syscall_ptr : felt*}() {
    let (sum) = takes_two_arguments_and_returns_one(1, 2);
    assert sum = 3;
    return ();
}`;
